import React from 'react';
import KaizenPaintedDoor from './KaizenPaintedDoor';
import KaizenDesktopLayout from './KaizenDesktopLayout';

const KaizenMainContent = ({
  hasAi,
  loadingStores,
  showSidebar,
  isScrolledToBottom,
  isExistingChatLoading,
  inputRef,
  scrollAreaRef,
  onScroll,
  onScrollToBottom,
  onSelectToolResult,
  onCreateJourney,
  onSelectJourneyAfterCreation,
  selectedToolResults,
  onCloseToolResult,
  onCloseToolResults,
  onSelectJourney,
  onNewChat
}) => {
  // Show painted door if AI is not enabled
  if (!hasAi) {
    return <KaizenPaintedDoor />;
  }

  return (
    <KaizenDesktopLayout
      isChatLoading={loadingStores}
      showSidebar={showSidebar}
      selectedToolResults={selectedToolResults}
      isScrolledToBottom={isScrolledToBottom}
      isExistingChatLoading={isExistingChatLoading}
      inputRef={inputRef}
      scrollAreaRef={scrollAreaRef}
      onScroll={onScroll}
      onScrollToBottom={onScrollToBottom}
      onSelectToolResult={onSelectToolResult}
      onCloseToolResult={onCloseToolResult}
      onCloseToolResults={onCloseToolResults}
      onCreateJourney={onCreateJourney}
      onSelectJourneyAfterCreation={onSelectJourneyAfterCreation}
      onSelectJourney={onSelectJourney}
      onNewChat={onNewChat}
    />
  );
};

export default KaizenMainContent;
